import { useState } from 'react';
import { atrMediaId } from '../lib/atrVideos';
import { youtubeEmbed } from '../lib/youtube';
import { useI18n } from '../lib/i18n';

/**
 * UN SOLO REPRODUCTOR para el video del ATR, venga de donde venga:
 *  - URL interna de un archivo subido (`/api/atr-videos/<id>/media`) → <video> nativo. La ruta
 *    contesta 302 a la URL firmada de R2 (soporta rangos: se puede saltar dentro del video).
 *  - YouTube → iframe embebido, como siempre.
 *  - Cualquier otro link (Drive, Dropbox) → "Open video ↗".
 *
 * Un archivo HEVC (iPhone en "High Efficiency") puede no reproducirse en Chrome/Edge de Windows:
 * si el <video> falla, se muestra el aviso con el link para abrirlo/bajarlo.
 */
export function AtrVideoPlayer({ url, codec, compact }: { url: string; codec?: string | null; compact?: boolean }) {
  const { t } = useI18n();
  const [fallo, setFallo] = useState(false);
  const id = atrMediaId(url);
  if (id) {
    return (
      <div>
        {!fallo && (
          <video
            controls playsInline preload="metadata" src={url}
            onError={() => setFallo(true)}
            style={{ width: '100%', maxHeight: compact ? 260 : 420, background: '#000', borderRadius: 10, display: 'block' }}
          />
        )}
        {(fallo || codec === 'hevc') && (
          <div className="muted" style={{ fontSize: 'var(--fs-2xs)', marginTop: 6 }}>
            {fallo ? t('atr.playFailed') : t('atr.hevcWarn')}
          </div>
        )}
        <a className="ve-open" href={url} target="_blank" rel="noreferrer">{t('atr.openFile')} ↗</a>
      </div>
    );
  }
  const embed = youtubeEmbed(url);
  if (embed) {
    return (
      <div>
        <div className="ve-frame"><iframe src={embed} title={t('atrv.frameTitle')} loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></div>
        <a className="ve-open" href={url} target="_blank" rel="noreferrer">{t('atrv.openYoutube')}</a>
      </div>
    );
  }
  return <a className="ve-open" href={url} target="_blank" rel="noreferrer">{t('atrv.openVideo')}</a>;
}
